export default (superClass) => {
    return class extends superClass {
        
        get durationType() {
            return this._data.duration_type;
        }

        get minDuration() {
            if (this.durationType == 'fixed') {
                return this._data.duration_fixed;
            }

            return this._data.duration_interval_min;
        }

        getMinDurationString(monthsShort = 'mån', yearsShort = 'år') {
            return this.minOrMaxDurationString('duration_interval_min', monthsShort, yearsShort)

        }

        get maxDuration() {
            if (this.durationType == 'fixed') {
                return this._data.duration_fixed;
            }

            return this._data.duration_interval_max;
        }

        getMaxDurationString(monthsShort = 'mån', yearsShort = 'år') {
            return this.minOrMaxDurationString('duration_interval_max', monthsShort, yearsShort)
        }

        getDurationString(monthsShort = 'mån', yearsShort = 'år') {
            if(this.durationType == 'fixed') {

                if(this._data.duration_fixed >= 12) {
                    return `${this.toYears(this._data.duration_fixed)} ${yearsShort}`;
                }   

                return `${this._data.duration_fixed} ${monthsShort}`;
            }

            if(this._data.duration_interval_min >= 12) {
                // only years
                return `${this.toYears(this._data.duration_interval_min)} - ${this.toYears(this._data.duration_interval_max)} ${yearsShort}`;
            }

            if(this._data.duration_interval_max < 12) {
                // only months
                return `${this._data.duration_interval_min} - ${this._data.duration_interval_max} ${monthsShort}`;
            }

            return `${this._data.duration_interval_min} ${monthsShort} - ${this.toYears(this._data.duration_interval_max)} ${yearsShort}`;
        }

        toYears(months) {
            return Math.round(months / 12);
        }

        minOrMaxDurationString(dataKey, monthsShort, yearsShort) {
            if (this.durationType == 'fixed') {
                if(this._data.duration_fixed >= 12) {
                    return `${this.toYears(this._data.duration_fixed)} ${yearsShort}`;
                }   

                return `${this._data.duration_fixed} ${monthsShort}`;
            }

            if(this._data[dataKey] >= 12) {
                // only years
                return `${this.toYears(this._data[dataKey])} ${yearsShort}`;
            }

            return `${this._data[dataKey]} ${monthsShort}`;
        }
    }
}